import React from "react"
import Logo, { Logos } from "./Logo";
const LazyLogo = React.lazy(() => import('./Logo'))

interface Props {
  logo: Logos
}

const Header = ({ logo }: Props) => {
  const isSSR = typeof window === "undefined"

  return (
    <header
      style={{
        marginBottom: `1.45rem`,
      }}
    >
      <div
        style={{
          padding: `1.0875rem 1.0875rem`,
        }}
      >
        <h1 style={{ margin: 0 }}>
          <a
            href="https://123erfasst.de"
            target="_blank"
            style={{
              color: `white`,
              textDecoration: `none`,
            }}
          >
            {!isSSR && (
              <React.Suspense fallback={<Logo logo={logo} />}>
                <LazyLogo logo={logo} />
              </React.Suspense>
            )}
          </a>
        </h1>
      </div>
    </header>
  )
}

export default Header
